import { render, staticRenderFns } from "./OsSelectCustomerDialog.vue?vue&type=template&id=4bb04d23&scoped=true"
import script from "./OsSelectCustomerDialog.vue?vue&type=script&lang=ts"
export * from "./OsSelectCustomerDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb04d23",
  null
  
)

export default component.exports